import { trackPageView } from '@finn-no/pulse-sdk';
import type { Money } from 'shared/util/money';
import type { RentalStatusPageType } from '@/domain/transaction';
import type { RentalStatusType } from '@/models/rentalStatus';

// TJVR_pv03
export const trackRentalRequestPageView = (adId: number, isAdvertiser: boolean) => {
    // Pulse tracker id: TJVR_pv03 (see tracking section in README.md)
    trackPageView({
        object: {
            name: 'TJVR rental request page',
            category: 'travel > holiday rental',
            type: 'ProcessFlow',
            isAdvertiser,
            taskInfo: 'Fill in guest information',
            stepName: 'Information to guest',
            items: [
                {
                    id: `${adId}`,
                    type: 'ClassifiedAd',
                    contentId: `${adId}`,
                    name: 'TJVR',
                    category: 'travel > holiday rental',
                },
            ],
        },
        vertical: {
            name: 'travel',
            subVertical: 'holiday_rental',
        },
    });
};

// TJVR_pv04
export const trackStatusPageView = (
    adId: number,
    bookingReference: string,
    currentStatus: RentalStatusType,
    price: Money,
    pageType: RentalStatusPageType,
) =>
    trackTransactionPageView(adId, bookingReference, currentStatus, price, 'TJVR status page', 'Status on rental', 'Status page', pageType);

export const trackTJVRQuarantinePageView = (
    adId: number,
    bookingReference: string,
    currentStatus: RentalStatusType,
    price: Money,
    pageType: RentalStatusPageType,
) =>
    trackTransactionPageView(
        adId,
        bookingReference,
        currentStatus,
        price,
        'TJVR quarantine page',
        'Information on quarantine status',
        'Quarantine page',
        pageType,
    );

export const trackTJVRSupportPageView = (
    adId: number,
    bookingReference: string,
    currentStatus: RentalStatusType,
    price: Money,
    pageType: RentalStatusPageType,
) =>
    trackTransactionPageView(
        adId,
        bookingReference,
        currentStatus,
        price,
        'TJVR support page',
        'Information on transactional process',
        'Info page',
        pageType,
    );

export const trackInsurancePageView = (adId: number, bookingReference: string, currentStatus: RentalStatusType, price: Money) =>
    trackTransactionPageView(
        adId,
        bookingReference,
        currentStatus,
        price,
        'TJVR insurance page',
        'Insurance claims',
        'Insurance page',
        'host',
    );

export const trackDisputePageView = (adId: number, bookingReference: string, currentStatus: RentalStatusType, price: Money) =>
    trackTransactionPageView(adId, bookingReference, currentStatus, price, 'TJVR problem page', 'Report problem', 'Problem page', 'tenant');

const trackTransactionPageView = (
    adId: number,
    bookingReference: string,
    currentStatus: RentalStatusType,
    price: Money,
    pageName: string,
    stepName: string,
    taskInfo: string,
    pageType: string,
) => {
    // Pulse tracker id: FHH_pv04 (see tracking section in README.md)
    trackPageView({
        object: {
            category: 'travel > holiday rental',
            type: 'ProcessFlow',
            taskInfo,
            contractId: bookingReference,
            name: pageName,
            stepName,
            taskName: currentStatus,
            isAdvertiser: pageType === 'host',
            items: [
                {
                    id: `${adId}`,
                    type: 'ClassifiedAd',
                    contentId: `${adId}`,
                    name: 'TJVR',
                    category: 'travel > holiday rental',
                },
                {
                    id: 'finntravel',
                    type: 'Travel',
                    totalPrice: price.value,
                },
            ],
        },
        vertical: {
            name: 'travel',
            subVertical: 'holiday_rental',
        },
    });
};

// TJVR_pv05
export const trackBookingArchivePageView = (pageType: RentalStatusPageType) => {
    // Pulse tracker id: FHH_pv04 (see tracking section in README.md)
    trackPageView({
        object: {
            name: `Overview of rental agreements as ${pageType === 'host' ? 'host' : 'guest'}`,
            category: 'travel > holiday rental',
            type: 'Page',
        },
        vertical: {
            name: 'travel',
            subVertical: 'holiday_rental',
        },
    });
};
